import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/src/Login';
import Restrictions from '@/views/src/Restrictions';
import PermissionControll from '@/views/src/PermissionControll';
import Services from '@/views/src/Services';
import Plates from '@/views/src/Plates';
import PlateGroups from '@/views/src/PlateGroups';
import Optimizer from '@/views/src/Optimizer';
import BatchOptimization from '@/views/src/BatchOptimization';
import Cenario from '@/views/src/Cenario';
import DashboardGestao from '@/views/src/DashboardGestao';
import util from '@/application/libs/util';
import permissionManager from '@/application/libs/permissionManager';
import { t } from 'i18next';

import RegisteredDataComponentMultiple from "@/components/src/RegisteredDataComponentMultiple"


import i18next from 'i18next';
import i18NextVue from 'i18next-vue';

import enUs from '../../assets/json/words/en_us.json';
import esCl from '../../assets/json/words/es_cl.json';
import defaultWords from '../../assets/json/messages.json';
// import ProdENV from '../../config/prod.env.js';

let lng = localStorage.getItem('lang') || 'pt-BR';


i18next.init({
	debug: false,
	lng,
	fallbackLng: 'pt-BR',
	resources: {
		'en-US': {
			translation: enUs.otimizador
		},
		'es-CL': {
			translation: esCl.otimizador
		},
		'pt-BR': {
			translation: defaultWords.otimizador
		}
	}
});

Vue.use(i18NextVue, { i18next });

Vue.use(Router)

const showBatchOptimizer = function() {
	if(process.env.LOGIN_ORGANIZATION_ID != "SAAS"){
		return true;
	}
	
	return false;
	
}

const isDev = process.env.NODE_ENV === 'development'

const router = new Router({
	routes: [
		{
			path: '/',
			name: 'Login',
			component: Login,
			showOnMenu: false
		},
		{
			path: '/dashboard-gestao',
			name: 'DashboardGestao',
			label: 'dashboard_gestao',
			menuLogo: 'poll-h',
			component: DashboardGestao,
			showOnMenu: true,
			menuKey: 'dashboardGestao'
		},
		{
			path: '/restrictions',
			name: 'Restrictions',
			label: 'contractual_restrictions',
			component: Restrictions,
			menuLogo: 'file-signature',
			showOnMenu: true,
			menuKey: 'restrictions'
		},
		{
			path: '/services',
			name: 'Services',
			label: 'service',
			component: Services,
			menuLogo: 'utensils',
			showOnMenu: true,
			menuKey: 'services'
		},
		{
			path: '/plates',
			name: 'Plates',
			label: 'plates',
			component: Plates,
			menuLogo: 'concierge-bell',
			showOnMenu: true,
			menuKey: 'plates'
		},
		{
			path: '/plate_groups',
			name: 'PlateGroups',
			label: 'group_of_dishes',
			component: PlateGroups,
			menuLogo: 'coins',
			showOnMenu: true,
			menuKey: 'plate_groups'
		},
		{
			path: '/Optimizer',
			name: 'Otimizador',
			label: 'generate_menu',
			menuLogo: 'tachometer-alt',
			component: Optimizer,
			showOnMenu: true,
			menuKey: 'Optimizer'
		},
		{
			path: '/batchOptimization',
			name: 'BatchOptimization',
			label: 'batch_menu',
			menuLogo: ['tachometer-alt', 'coins'],
			component: BatchOptimization,
			showOnMenu: false, //showBatchOptimizer(),
			menuKey: 'batchOptimization'
		},
		{
			path: '/ResultAna',
			name: 'Analise de Resultados',
			label: 'results_analysis',
			menuLogo: 'poll',
			component: Optimizer,
			showOnMenu: true,
			menuKey: 'ResultAna'
		},
		{
			path: '/PermissionControll',
			name: 'Controle de Permissões',
			label: 'permissions_control',
			menuLogo: 'user-lock',
			component: PermissionControll,
			showOnMenu: true,
			menuKey: 'PermissionControll'
		},
		{
		  path: '/cenario/:codigo',
		  name: 'Cenario',
		  component: Cenario,
		  showOnMenu: false
		}
	]
});

router.beforeEach((to, from, next) => {
	let boToken = util.getLocalVar('backoffice_token');

	if (!(/.+\..+\..+/.test(boToken))) {
		boToken = '';
	}

	//Permissão de rota publica
	const rotasPublicas = ['/cenario'];
	if (rotasPublicas.some((rota) => to.path.startsWith(rota))) {
		next();
		return;
	}

	const permissions = permissionManager.getMenuAccess();
	if (!boToken && to.path !== '/') {
		next('/');
		localStorage.removeItem('backoffice_token');
		localStorage.removeItem('userData');
		localStorage.removeItem('backOfficeData');
		sessionStorage.removeItem('filterData');
	}
	else if (permissions[to.path] !== false) {
		next();
	}
	else if (router.options.routes.find(r => permissions[r.path])) {
		const newPath = router.options.routes.find(r => permissions[r.path]);
		next(newPath);
	}
	else {
		util.showErrorNotification({ title: t('user_without_permission'), text: t('request_permission') });
	}

});

export default router;
